module.exports = __webpack_public_path__ + "media/assets/icons/ic-arrow-long-96511c4d82479b37d654c57622488b21.svg";